import { publicBrandScope, rememberBrand } from "@/lib/brand-cache";
import type { PublicBranding } from "@/contracts";
import { PublicBrandingSchema } from "@/contracts";
import type { VisualBranding } from "@/lib/branding-theme";
import { publicBrandingQueryKey } from "@/api";
import { queryClient } from "@/lib/query-client";
import { resolvePublicTenantHost } from "@/lib/api-base-url";

const text = (value: unknown) => (typeof value === "string" ? value.trim() : "");
export function resolvePwaBranding(brand?: VisualBranding) {
  const background = text(brand?.colors?.pwaBackground);
  const name = (
    text(brand?.texts?.pwaName) ||
    text(brand?.settings?.displayName) ||
    "Education"
  ).slice(0, 80);
  return {
    name,
    shortName: (text(brand?.texts?.pwaShortName) || name).slice(0, 30),
    icon:
      text(brand?.images?.pwaIcon) ||
      brand?.logo ||
      text(brand?.images?.logoLight) ||
      "/logo-mark.svg",
    background: /^#(?:[\da-f]{3}|[\da-f]{6})$/i.test(background) ? background : "#08090b",
  };
}

// O servidor publica somente a projeção pública do host. Ela já está pronta
// antes de montar o React e não depende da conta que estiver autenticada.
export function initializePwaBranding(): PublicBranding | undefined {
  const raw = document.getElementById("edu-public-branding")?.textContent;
  if (!raw) return;
  try {
    const result = PublicBrandingSchema.safeParse(JSON.parse(raw));
    if (!result.success) return;
    const host = resolvePublicTenantHost();
    queryClient.setQueryData(publicBrandingQueryKey(host), result.data);
    rememberBrand(publicBrandScope(host), result.data);
    return result.data;
  } catch {
    return;
  }
}
